import { normalizeApiError } from '../services/apiError';
import type { PlanningStatus } from '../store/services/planningRuntimeApi';

type FetchPlanningStatus = () => Promise<PlanningStatus>;

const DEFAULT_RETRY_DELAYS_MS = [0, 500, 1500] as const;

const wait = (delayMs: number): Promise<void> => (
  delayMs > 0
    ? new Promise((resolve) => { globalThis.setTimeout(resolve, delayMs); })
    : Promise.resolve()
);

export const planningStatusMatchesTrigger = (
  status: PlanningStatus | undefined,
  messageId: string,
): boolean => Boolean(
  status?.run_message_id === messageId
  && ['queued', 'running', 'queued_for_resume', 'completed'].includes(status.run_status || ''),
);

const fetchMatchingPlanningStatus = async (
  fetchPlanningStatus: FetchPlanningStatus,
  messageId: string,
): Promise<boolean> => {
  try {
    return planningStatusMatchesTrigger(await fetchPlanningStatus(), messageId);
  } catch {
    return false;
  }
};

export const reconcileAmbiguousPlanningTrigger = async (
  error: unknown,
  messageId: string,
  fetchPlanningStatus: FetchPlanningStatus,
  retryDelaysMs: readonly number[] = DEFAULT_RETRY_DELAYS_MS,
): Promise<boolean> => {
  const errorKind = normalizeApiError(error).kind;

  if (errorKind !== 'timeout' && errorKind !== 'network') return false;

  for (const delayMs of retryDelaysMs) {
    await wait(delayMs);
    if (await fetchMatchingPlanningStatus(fetchPlanningStatus, messageId)) return true;
  }

  return false;
};
